export const RESET = 'session/RESET';
export const RECEIVE_ACCESS_TOKEN = 'session/RECEIVE_ACCESS_TOKEN';
export const RECEIVE_USER = 'session/RECEIVE_USER';
export const REFRESH_USER = 'session/REFRESH_USER';
export const PAPERLESS_TERMS = 'session/PAPERLESS_TERMS';
export const RECEIVE_GROUP = 'session/RECEIVE_GROUP';

export const PROFILE_FETCH_REQUEST = 'auth/PROFILE_FETCH_REQUEST';
export const PROFILE_FETCH_ERROR = 'auth/PROFILE_FETCH_ERROR';
export const UPDATE_CONNECTED_ACCOUNT = 'auth/UPDATE_CONNECTED_ACCOUNT';
export const UPDATE_CONNECTED_ACCOUNT_SUCCESS =
  'auth/UPDATE_CONNECTED_ACCOUNT_SUCCESS';
export const PATCH_CONNECTED_ACCOUNT = 'auth/PATCH_CONNECTED_ACCOUNT';
export const PATCH_CONNECTED_ACCOUNT_SUCCESS =
  'auth/PATCH_CONNECTED_ACCOUNT_SUCCESS';
